import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { withRouter } from 'react-router-dom';
import { SimpleLoadingComponent } from '../../utils/apollo';
import HEAccountUsersPage from './he-account-users-page';

const query = gql`
  query HEAccountDetails($id: ID!) {
    node(id: $id) {
      id
      ...on HEAccount {
        id
        name
        ...HEAccountUsersTable
      }
    }
    viewer {
      id
      enabledFeatures
    }
  }
  ${HEAccountUsersPage.getFragments()[0]}
`;

const graphqlData = graphql(query, {
  options: ({ match }) => {
    const { id } = match.params;
    return {
      variables: {
        id,
      },
    };
  },
});

export default withRouter(SimpleLoadingComponent(graphqlData)(HEAccountUsersPage));
